<template>
  <div class="sino-card" v-loading.fullscreen.lock="loading">
    <div class="sion-card-title">
      <div @click="selectTab('welfareTab')" :class="['title' , active == 'welfareTab'?'active': '']">生日慰问<span v-if='active == "welfareTab"'></span></div>
      <div @click="selectTab('activityTab')" :class="['title' , active == 'activityTab'?'active': '']">活动奖品<span v-if='active == "activityTab"'></span></div>
    </div>
    <div class="welfareTab" v-show='active == "welfareTab"'>
        <div class="card-box" v-for="item in welfareList" :key="item.welfareId" @click="openWelfareDetail(item)">
          <div class="card-title">
              <img src="@/images/birthdayIcon.png" alt srcset>
              <span class="reddian" v-if="item.status == 0"> · </span>
              <span :style="{'margin': item.status == 0 ? '-.2rem' : ''}">{{item.welfareName}}</span>
          </div>
          <div class="card-content">
              <div class="content-text" v-html='item.content || "无"'></div>
              <div class="content-date">领取时间：{{item.startTime}}</div>
          </div>
          <div class="card-footer">
              查看详情
              <i class="cubeic-arrow"></i>
          </div>
        </div>
    </div>
    <div class="activityTab" v-show='active == "activityTab"'>
        <div class="card-box" v-for="item in activityList" :key="item.activityId" @click="openActivityDetail(item)">
          <div class="card-title">
              <img src="@/images/birthdayIcon.png" alt srcset>
              <span>{{item.activityName}}</span>
          </div>
          <div class="card-content">
              <div class="content-text" v-html='item.content'></div>
              <div class="content-date">领取时间：{{item.startTime}}</div>
          </div>
          <div class="card-footer">
              查看详情
              <i class="cubeic-arrow"></i>
          </div>
      </div>
    </div>
    <div v-if="(active=='welfareTab'&&welfareList.length==0) || (active=='activityTab'&&activityList.length==0)" class="blank">
      <img src="@/images/404-02.png" alt>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { getAppWelfareList ,getActivityPrizesList,getUserInformation,delCookie} from "@/common/api";
import { toast } from "@/common/api/api.js";
export default {
  data() {
    return {
      welfareList: [],
      activityList:[],
      loading: false,
      active:'welfareTab',
      currentBaseInfo: JSON.parse(localStorage.getItem("loginInfo"))
    };
  },
  created() {
    this.getWelfareList();
    this.getActivityList();
    let id = JSON.parse(window.localStorage.getItem("loginInfo")).id || "";
      getUserInformation({
        id: id
      }).then(res => {
        if (res.code == 200) {
          if (!res.data.status) {
            this.$createDialog({
              type: "alert",
              title: "提示",
              content: "登录失效,请重新登录",
              icon: "cubeic-alert",
              confirmBtn: {
                text: "退出",
                active: true,
                href: "javascript:;"
              },
              onConfirm: () => {
                window.localStorage.clear();
                delCookie("sessionId");
                this.$router.push("/login");
                window.location.reload();
              }
            }).show();
          }
        }
      });
  },
  methods: {
    getWelfareList() {  //获取生日慰问列表
      this.loading = true;
      let data={
        unionId:JSON.parse(localStorage.getItem('loginInfo')).unionId,
        welfareCategory:'1'
      };
      getAppWelfareList(data).then(res => {
        if (res.code == 200) {
          res.data.forEach(item=>{
            item.content = item.content.replace(new RegExp("&lt;", "g"), "<").replace(new RegExp("&quot;", "g"), "").replace(new RegExp("&gt;", "g"), ">");
          })
          this.welfareList = res.data;
          this.loading = false;
        } else {
          this.loading = false;
          toast(this, res.message, "error");
        }
      });
    },
    getActivityList(){
      getActivityPrizesList({
        staffId : this.currentBaseInfo.identity == '3'?  '' : this.currentBaseInfo.id ,
        unionId:this.currentBaseInfo.identity == '3'?  this.currentBaseInfo.unionId : '',
        welfareCategory:'1'
      }).then(res=>{
        if(res.code == 200){
          res.data.forEach(item=>{
            item.content = item.content.replace(new RegExp("&lt;", "g"), "<").replace(new RegExp("&quot;", "g"), "").replace(new RegExp("&gt;", "g"), ">");
          })
          this.activityList = res.data
        }
      })
    },
    selectTab(type){
      this.active = type 
    },
    openWelfareDetail(option){
      this.$router.push({
        path:"/greetingsDetail",
        query:{
          welfareId:option.welfareId,
          status:option.status,
          source:'m2e'
        }
      })
    },
    openActivityDetail(option){
      this.$router.push({
        path: "/activityDetail",
        query: {
          activityId: option.activityId,
          source: "me1",
          status:option.status,
          level:option.creatorOfficeLevel,
          welfareCategory:'1'
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "personnelManagement") {
      next({ name: "personalCenter" });
    } else {
      next(); // 注意：这边next必须要写
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.sino-card {
  .card-box {
    background: rgba(255, 255, 255, 1);
    padding: 0.3rem 0.42rem 0 0.42rem;
    margin-bottom: 0.4rem;

    .card-title {
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
      border-bottom: 1px solid #e5e5e5;

      img {
        width:18px;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        margin-left:6px;
      }
    }

    .card-content {
      height: 60px;
      padding-bottom: 0.12rem;
      border-bottom: 1px solid #e5e5e5;

      .content-text {
        height:40px;
        line-height:40px;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        img{
          display :none;
          max-width:100%;
        }
        p{
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .content-date {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: rgba(172, 172, 183, 1);
      }
    }

    .card-footer {
      height: 40px;
      line-height: 40px;
      color: rgba(172, 172, 183, 1);
      font-size: 12px;
      i {
        display:inline-block;
        margin-left:6px;
        font-size: 16px;
        float: right;
        color: rgba(206, 206, 206, 0.6);
      }
    }
  }

  .sion-card-title {
    height: 44px;
    background: #ffffff;
    margin-bottom .3rem
    display flex
    .title{
        flex 1
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position relative
        padding-bottom: .3rem;
        font-size 16px
        color:rgba(153,153,153,1)
        span {
            height: 4px;
            display: inline-block;
            width: 25px;
            position: absolute;
            bottom: 0px;
            left : 45%;
            border-bottom 3px solid rgba(56,199,196,1);            
        }
    }
    .active{
        color #38C7C4    
    }
  }
}

.blank {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 200px;
  }
}
.reddian{
    color: red;
    position: relative;
    top: -10px;
    left: -11px;
}
</style>